import React, { useState, useEffect } from 'react';

const Presentation = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const totalSlides = 12;

  const nextSlide = () => {
    if (currentSlide < totalSlides - 1) {
      setCurrentSlide((prev) => prev + 1);
    }
  };
  const prevSlide = () => setCurrentSlide((prev) => (prev - 1 + totalSlides) % totalSlides);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'ArrowRight' || e.key === ' ') nextSlide();
      if (e.key === 'ArrowLeft') prevSlide();
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, []);

  const slides = [
    // Slide 1: Title
    <div key={1} style={{ textAlign: 'center', paddingTop: '100px' }}>
      <div style={{ width: '80px', height: '80px', background: '#3b82f6', borderRadius: '15px', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'white', fontSize: '2rem', fontWeight: 'bold', margin: '0 auto 20px' }}>PJ</div>
      <h1 style={{ fontSize: '3rem', color: '#1e293b', marginBottom: '20px' }}>ParkJini</h1>
      <h2 style={{ color: '#64748b', fontSize: '2rem', marginBottom: '40px' }}>Ticketing as a Service Platform</h2>
      <div style={{ margin: '40px 0' }}>
        <p style={{ fontSize: '1.5rem', color: '#3b82f6', fontWeight: '600' }}>Presented by</p>
        <h3 style={{ color: '#1e293b' }}>Bijdutronix Innovations Private Limited</h3>
      </div>
      <div style={{ background: 'linear-gradient(135deg, #3b82f6, #8b5cf6)', color: 'white', padding: '40px', borderRadius: '20px', marginTop: '60px' }}>
        <h3>Revolutionizing Digital Ticketing for Government Parks & Temples</h3>
        <p style={{ fontSize: '1.3rem', marginTop: '20px' }}>Multi-tenant • Secure • Scalable • Revenue Optimized</p>
      </div>
    </div>,

    // Slide 2: Problem Statement
    <div key={2}>
      <h2 style={{ fontSize: '2.5rem', color: '#3b82f6', marginBottom: '30px' }}>🎯 Problem Statement</h2>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '30px', margin: '30px 0' }}>
        <div style={{ background: 'white', padding: '30px', borderRadius: '15px', boxShadow: '0 10px 30px rgba(0,0,0,0.1)' }}>
          <h4 style={{ color: '#3b82f6', fontSize: '1.4rem', marginBottom: '15px' }}>❌ Current Challenges</h4>
          <ul style={{ marginLeft: '20px' }}>
            <li>Manual ticketing systems</li>
            <li>Revenue leakage</li>
            <li>Long queues & poor visitor experience</li>
            <li>Limited payment options</li>
            <li>No real-time analytics</li>
            <li>Fraud & duplicate tickets</li>
          </ul>
        </div>
        <div style={{ background: 'white', padding: '30px', borderRadius: '15px', boxShadow: '0 10px 30px rgba(0,0,0,0.1)' }}>
          <h4 style={{ color: '#3b82f6', fontSize: '1.4rem', marginBottom: '15px' }}>💰 Financial Impact</h4>
          <ul style={{ marginLeft: '20px' }}>
            <li>30-40% revenue loss due to manual processes</li>
            <li>High operational costs</li>
            <li>Limited visitor capacity management</li>
            <li>No dynamic pricing capabilities</li>
            <li>Poor financial reporting</li>
          </ul>
        </div>
      </div>
      <div style={{ background: 'linear-gradient(135deg, #3b82f6, #8b5cf6)', color: 'white', padding: '40px', borderRadius: '20px', textAlign: 'center' }}>
        <h3>Government parks and temples lose ₹1000+ crores annually due to inefficient ticketing systems</h3>
      </div>
    </div>,

    // Slide 3: Solution Overview
    <div key={3}>
      <h2 style={{ fontSize: '2.5rem', color: '#3b82f6', marginBottom: '30px' }}>✅ ParkJini Solution</h2>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '30px', margin: '30px 0' }}>
        <div style={{ background: 'white', padding: '30px', borderRadius: '15px', boxShadow: '0 10px 30px rgba(0,0,0,0.1)' }}>
          <h4 style={{ color: '#3b82f6', fontSize: '1.4rem', marginBottom: '15px' }}>🏛️ Multi-Tenant Architecture</h4>
          <p>Single platform serving multiple parks, temples, and government facilities with isolated data and custom branding.</p>
        </div>
        <div style={{ background: 'white', padding: '30px', borderRadius: '15px', boxShadow: '0 10px 30px rgba(0,0,0,0.1)' }}>
          <h4 style={{ color: '#3b82f6', fontSize: '1.4rem', marginBottom: '15px' }}>💳 Integrated Payment Gateways</h4>
          <p>PayU, ICICI, IDFC integration with secure payment processing and instant confirmations.</p>
        </div>
        <div style={{ background: 'white', padding: '30px', borderRadius: '15px', boxShadow: '0 10px 30px rgba(0,0,0,0.1)' }}>
          <h4 style={{ color: '#3b82f6', fontSize: '1.4rem', marginBottom: '15px' }}>📱 Digital Ticket Management</h4>
          <p>QR code generation, real-time validation, and mobile-first user experience.</p>
        </div>
        <div style={{ background: 'white', padding: '30px', borderRadius: '15px', boxShadow: '0 10px 30px rgba(0,0,0,0.1)' }}>
          <h4 style={{ color: '#3b82f6', fontSize: '1.4rem', marginBottom: '15px' }}>📊 Advanced Analytics</h4>
          <p>Real-time revenue tracking, visitor analytics, and comprehensive reporting dashboards.</p>
        </div>
      </div>
      <div style={{ display: 'flex', justifyContent: 'space-around', margin: '40px 0' }}>
        <div style={{ textAlign: 'center' }}>
          <div style={{ fontSize: '3rem', fontWeight: 'bold', color: '#3b82f6' }}>99.9%</div>
          <div style={{ fontSize: '1.1rem', color: '#64748b' }}>Uptime</div>
        </div>
        <div style={{ textAlign: 'center' }}>
          <div style={{ fontSize: '3rem', fontWeight: 'bold', color: '#3b82f6' }}>50+</div>
          <div style={{ fontSize: '1.1rem', color: '#64748b' }}>Locations Ready</div>
        </div>
        <div style={{ textAlign: 'center' }}>
          <div style={{ fontSize: '3rem', fontWeight: 'bold', color: '#3b82f6' }}>3</div>
          <div style={{ fontSize: '1.1rem', color: '#64748b' }}>Payment Gateways</div>
        </div>
      </div>
    </div>,

    // Slide 4: Target Market
    <div key={4}>
      <h2 style={{ fontSize: '2.5rem', color: '#3b82f6', marginBottom: '30px' }}>🎯 Target Market</h2>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '30px', margin: '30px 0' }}>
        <div style={{ background: 'white', padding: '30px', borderRadius: '15px', boxShadow: '0 10px 30px rgba(0,0,0,0.1)' }}>
          <h4 style={{ color: '#3b82f6', fontSize: '1.4rem', marginBottom: '15px' }}>🏞️ Government Parks</h4>
          <ul style={{ marginLeft: '20px' }}>
            <li>National Parks & Wildlife Sanctuaries</li>
            <li>State Tourism Parks</li>
            <li>Botanical Gardens</li>
            <li>Archaeological Sites</li>
          </ul>
        </div>
        <div style={{ background: 'white', padding: '30px', borderRadius: '15px', boxShadow: '0 10px 30px rgba(0,0,0,0.1)' }}>
          <h4 style={{ color: '#3b82f6', fontSize: '1.4rem', marginBottom: '15px' }}>🕉️ Religious Institutions</h4>
          <ul style={{ marginLeft: '20px' }}>
            <li>Major Temples & Shrines</li>
            <li>Pilgrimage Sites</li>
            <li>Religious Complexes</li>
            <li>Heritage Temples</li>
          </ul>
        </div>
        <div style={{ background: 'white', padding: '30px', borderRadius: '15px', boxShadow: '0 10px 30px rgba(0,0,0,0.1)' }}>
          <h4 style={{ color: '#3b82f6', fontSize: '1.4rem', marginBottom: '15px' }}>🏛️ Government Facilities</h4>
          <ul style={{ marginLeft: '20px' }}>
            <li>Museums & Galleries</li>
            <li>Convention Centers</li>
            <li>Public Event Venues</li>
            <li>Heritage Sites</li>
          </ul>
        </div>
      </div>
      <div style={{ background: 'linear-gradient(135deg, #3b82f6, #8b5cf6)', color: 'white', padding: '40px', borderRadius: '20px', textAlign: 'center' }}>
        <h3>Market Size: ₹5000+ Crores</h3>
        <p>India has 500+ major tourist destinations and 2000+ significant temples requiring digital ticketing solutions</p>
      </div>
    </div>,

    // Slide 5: Key Features
    <div key={5}>
      <h2 style={{ fontSize: '2.5rem', color: '#3b82f6', marginBottom: '30px' }}>🚀 Key Features</h2>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '30px', margin: '30px 0' }}>
        <div style={{ background: 'white', padding: '30px', borderRadius: '15px', boxShadow: '0 10px 30px rgba(0,0,0,0.1)' }}>
          <h4 style={{ color: '#3b82f6', fontSize: '1.4rem', marginBottom: '15px' }}>👑 Super Admin Dashboard</h4>
          <ul style={{ marginLeft: '20px' }}>
            <li>Onboard unlimited tenants</li>
            <li>Monitor system-wide analytics</li>
            <li>Manage subscriptions</li>
            <li>Global configuration</li>
          </ul>
        </div>
        <div style={{ background: 'white', padding: '30px', borderRadius: '15px', boxShadow: '0 10px 30px rgba(0,0,0,0.1)' }}>
          <h4 style={{ color: '#3b82f6', fontSize: '1.4rem', marginBottom: '15px' }}>🎫 Flexible Ticket Types</h4>
          <ul style={{ marginLeft: '20px' }}>
            <li>Entry tickets with time slots</li>
            <li>Parking reservations</li>
            <li>Event bookings</li>
            <li>VIP/Premium access</li>
          </ul>
        </div>
        <div style={{ background: 'white', padding: '30px', borderRadius: '15px', boxShadow: '0 10px 30px rgba(0,0,0,0.1)' }}>
          <h4 style={{ color: '#3b82f6', fontSize: '1.4rem', marginBottom: '15px' }}>💰 Revenue Optimization</h4>
          <ul style={{ marginLeft: '20px' }}>
            <li>Dynamic pricing</li>
            <li>Peak/off-peak rates</li>
            <li>Group discounts</li>
            <li>Season passes</li>
          </ul>
        </div>
        <div style={{ background: 'white', padding: '30px', borderRadius: '15px', boxShadow: '0 10px 30px rgba(0,0,0,0.1)' }}>
          <h4 style={{ color: '#3b82f6', fontSize: '1.4rem', marginBottom: '15px' }}>🔒 Security & Compliance</h4>
          <ul style={{ marginLeft: '20px' }}>
            <li>QR code validation</li>
            <li>Fraud prevention</li>
            <li>PCI DSS compliance</li>
            <li>Data encryption</li>
          </ul>
        </div>
      </div>
    </div>,

    // Slide 6: Technology Stack
    <div key={6}>
      <h2 style={{ fontSize: '2.5rem', color: '#3b82f6', marginBottom: '30px' }}>⚡ Technology Stack</h2>
      <div style={{ background: 'white', padding: '30px', borderRadius: '15px', boxShadow: '0 10px 30px rgba(0,0,0,0.1)', margin: '30px 0' }}>
        <h4 style={{ color: '#3b82f6', fontSize: '1.4rem', marginBottom: '15px' }}>Backend Infrastructure</h4>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '15px', margin: '20px 0' }}>
          <div style={{ background: '#e2e8f0', padding: '10px 20px', borderRadius: '25px', fontSize: '1rem', color: '#475569' }}>Node.js</div>
          <div style={{ background: '#e2e8f0', padding: '10px 20px', borderRadius: '25px', fontSize: '1rem', color: '#475569' }}>Express.js</div>
          <div style={{ background: '#e2e8f0', padding: '10px 20px', borderRadius: '25px', fontSize: '1rem', color: '#475569' }}>MongoDB</div>
          <div style={{ background: '#e2e8f0', padding: '10px 20px', borderRadius: '25px', fontSize: '1rem', color: '#475569' }}>JWT Authentication</div>
          <div style={{ background: '#e2e8f0', padding: '10px 20px', borderRadius: '25px', fontSize: '1rem', color: '#475569' }}>Payment Gateway APIs</div>
        </div>
      </div>
      <div style={{ background: 'white', padding: '30px', borderRadius: '15px', boxShadow: '0 10px 30px rgba(0,0,0,0.1)', margin: '30px 0' }}>
        <h4 style={{ color: '#3b82f6', fontSize: '1.4rem', marginBottom: '15px' }}>Frontend & Mobile</h4>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '15px', margin: '20px 0' }}>
          <div style={{ background: '#e2e8f0', padding: '10px 20px', borderRadius: '25px', fontSize: '1rem', color: '#475569' }}>React.js</div>
          <div style={{ background: '#e2e8f0', padding: '10px 20px', borderRadius: '25px', fontSize: '1rem', color: '#475569' }}>Responsive Design</div>
          <div style={{ background: '#e2e8f0', padding: '10px 20px', borderRadius: '25px', fontSize: '1rem', color: '#475569' }}>PWA Support</div>
          <div style={{ background: '#e2e8f0', padding: '10px 20px', borderRadius: '25px', fontSize: '1rem', color: '#475569' }}>QR Code Generation</div>
        </div>
      </div>
      <div style={{ background: 'white', padding: '30px', borderRadius: '15px', boxShadow: '0 10px 30px rgba(0,0,0,0.1)', margin: '30px 0' }}>
        <h4 style={{ color: '#3b82f6', fontSize: '1.4rem', marginBottom: '15px' }}>Payment & Security</h4>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '15px', margin: '20px 0' }}>
          <div style={{ background: '#e2e8f0', padding: '10px 20px', borderRadius: '25px', fontSize: '1rem', color: '#475569' }}>PayU Integration</div>
          <div style={{ background: '#e2e8f0', padding: '10px 20px', borderRadius: '25px', fontSize: '1rem', color: '#475569' }}>ICICI CCAvenue</div>
          <div style={{ background: '#e2e8f0', padding: '10px 20px', borderRadius: '25px', fontSize: '1rem', color: '#475569' }}>IDFC Gateway</div>
          <div style={{ background: '#e2e8f0', padding: '10px 20px', borderRadius: '25px', fontSize: '1rem', color: '#475569' }}>SSL Encryption</div>
          <div style={{ background: '#e2e8f0', padding: '10px 20px', borderRadius: '25px', fontSize: '1rem', color: '#475569' }}>Hash Verification</div>
        </div>
      </div>
    </div>,

    // Slide 7: Revenue Model
    <div key={7}>
      <h2 style={{ fontSize: '2.5rem', color: '#3b82f6', marginBottom: '30px' }}>💼 Revenue Model</h2>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '30px', margin: '30px 0' }}>
        <div style={{ background: 'white', padding: '30px', borderRadius: '15px', boxShadow: '0 10px 30px rgba(0,0,0,0.1)' }}>
          <h4 style={{ color: '#3b82f6', fontSize: '1.4rem', marginBottom: '15px' }}>🏦 For Banks</h4>
          <ul style={{ marginLeft: '20px' }}>
            <li>Transaction fee sharing (1-2%)</li>
            <li>Payment gateway partnerships</li>
            <li>Digital lending opportunities</li>
            <li>Government account acquisition</li>
          </ul>
        </div>
        <div style={{ background: 'white', padding: '30px', borderRadius: '15px', boxShadow: '0 10px 30px rgba(0,0,0,0.1)' }}>
          <h4 style={{ color: '#3b82f6', fontSize: '1.4rem', marginBottom: '15px' }}>🏛️ For Government</h4>
          <ul style={{ marginLeft: '20px' }}>
            <li>30-50% increase in revenue</li>
            <li>Reduced operational costs</li>
            <li>Better visitor management</li>
            <li>Transparent financial reporting</li>
          </ul>
        </div>
      </div>
      <div style={{ background: 'linear-gradient(135deg, #3b82f6, #8b5cf6)', color: 'white', padding: '40px', borderRadius: '20px', textAlign: 'center' }}>
        <h3>Projected Annual Revenue: ₹50+ Crores</h3>
        <p>Based on 100 locations with average 1000 daily visitors at ₹100 average ticket price</p>
      </div>
      <div style={{ display: 'flex', justifyContent: 'space-around', margin: '40px 0' }}>
        <div style={{ textAlign: 'center' }}>
          <div style={{ fontSize: '3rem', fontWeight: 'bold', color: '#3b82f6' }}>₹2-5</div>
          <div style={{ fontSize: '1.1rem', color: '#64748b' }}>Per Transaction</div>
        </div>
        <div style={{ textAlign: 'center' }}>
          <div style={{ fontSize: '3rem', fontWeight: 'bold', color: '#3b82f6' }}>15%</div>
          <div style={{ fontSize: '1.1rem', color: '#64748b' }}>Revenue Share</div>
        </div>
        <div style={{ textAlign: 'center' }}>
          <div style={{ fontSize: '3rem', fontWeight: 'bold', color: '#3b82f6' }}>100+</div>
          <div style={{ fontSize: '1.1rem', color: '#64748b' }}>Target Locations</div>
        </div>
      </div>
    </div>,

    // Slide 8: Implementation Plan
    <div key={8}>
      <h2 style={{ fontSize: '2.5rem', color: '#3b82f6', marginBottom: '30px' }}>📋 Implementation Roadmap</h2>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '30px', margin: '30px 0' }}>
        <div style={{ background: 'white', padding: '30px', borderRadius: '15px', boxShadow: '0 10px 30px rgba(0,0,0,0.1)' }}>
          <h4 style={{ color: '#3b82f6', fontSize: '1.4rem', marginBottom: '15px' }}>Phase 1 (Month 1-2)</h4>
          <ul style={{ marginLeft: '20px' }}>
            <li>Pilot with 5 government parks</li>
            <li>Banking partnership setup</li>
            <li>Payment gateway integration</li>
            <li>Staff training programs</li>
          </ul>
        </div>
        <div style={{ background: 'white', padding: '30px', borderRadius: '15px', boxShadow: '0 10px 30px rgba(0,0,0,0.1)' }}>
          <h4 style={{ color: '#3b82f6', fontSize: '1.4rem', marginBottom: '15px' }}>Phase 2 (Month 3-6)</h4>
          <ul style={{ marginLeft: '20px' }}>
            <li>Scale to 25 locations</li>
            <li>Temple partnerships</li>
            <li>Mobile app launch</li>
            <li>Advanced analytics</li>
          </ul>
        </div>
        <div style={{ background: 'white', padding: '30px', borderRadius: '15px', boxShadow: '0 10px 30px rgba(0,0,0,0.1)' }}>
          <h4 style={{ color: '#3b82f6', fontSize: '1.4rem', marginBottom: '15px' }}>Phase 3 (Month 7-12)</h4>
          <ul style={{ marginLeft: '20px' }}>
            <li>100+ locations onboarded</li>
            <li>Multi-state expansion</li>
            <li>AI-powered insights</li>
            <li>White-label solutions</li>
          </ul>
        </div>
      </div>
      <div style={{ background: 'linear-gradient(135deg, #3b82f6, #8b5cf6)', color: 'white', padding: '40px', borderRadius: '20px', textAlign: 'center' }}>
        <h3>Ready to Deploy</h3>
        <p>Platform is production-ready with live payment gateways and can be deployed same day</p>
      </div>
    </div>,

    // Slide 9: Competitive Advantage
    <div key={9}>
      <h2 style={{ fontSize: '2.5rem', color: '#3b82f6', marginBottom: '30px' }}>🏆 Competitive Advantage</h2>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '30px', margin: '30px 0' }}>
        <div style={{ background: 'white', padding: '30px', borderRadius: '15px', boxShadow: '0 10px 30px rgba(0,0,0,0.1)' }}>
          <h4 style={{ color: '#3b82f6', fontSize: '1.4rem', marginBottom: '15px' }}>✅ Our Advantages</h4>
          <ul style={{ marginLeft: '20px' }}>
            <li>Government-focused design</li>
            <li>Multi-tenant architecture</li>
            <li>Integrated payment solutions</li>
            <li>Real-time analytics</li>
            <li>Scalable infrastructure</li>
            <li>Local support team</li>
          </ul>
        </div>
        <div style={{ background: 'white', padding: '30px', borderRadius: '15px', boxShadow: '0 10px 30px rgba(0,0,0,0.1)' }}>
          <h4 style={{ color: '#3b82f6', fontSize: '1.4rem', marginBottom: '15px' }}>❌ Competitor Limitations</h4>
          <ul style={{ marginLeft: '20px' }}>
            <li>Generic solutions</li>
            <li>High implementation costs</li>
            <li>Limited customization</li>
            <li>Poor government integration</li>
            <li>Complex user interfaces</li>
          </ul>
        </div>
      </div>
      <div style={{ display: 'flex', justifyContent: 'space-around', margin: '40px 0' }}>
        <div style={{ textAlign: 'center' }}>
          <div style={{ fontSize: '3rem', fontWeight: 'bold', color: '#3b82f6' }}>70%</div>
          <div style={{ fontSize: '1.1rem', color: '#64748b' }}>Cost Reduction</div>
        </div>
        <div style={{ textAlign: 'center' }}>
          <div style={{ fontSize: '3rem', fontWeight: 'bold', color: '#3b82f6' }}>5x</div>
          <div style={{ fontSize: '1.1rem', color: '#64748b' }}>Faster Implementation</div>
        </div>
        <div style={{ textAlign: 'center' }}>
          <div style={{ fontSize: '3rem', fontWeight: 'bold', color: '#3b82f6' }}>24/7</div>
          <div style={{ fontSize: '1.1rem', color: '#64748b' }}>Support</div>
        </div>
      </div>
    </div>,

    // Slide 10: Call to Action
    <div key={10} style={{ textAlign: 'center', paddingTop: '80px' }}>
      <h2 style={{ fontSize: '2.5rem', color: '#3b82f6', marginBottom: '30px' }}>🤝 Partnership Opportunity</h2>
      <div style={{ background: 'linear-gradient(135deg, #3b82f6, #8b5cf6)', color: 'white', padding: '40px', borderRadius: '20px', margin: '40px 0' }}>
        <h3>Join the Digital Transformation</h3>
        <p style={{ fontSize: '1.4rem', margin: '20px 0' }}>Partner with Bijdutronix Innovations to revolutionize government ticketing systems</p>
      </div>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '30px', margin: '30px 0' }}>
        <div style={{ background: 'white', padding: '30px', borderRadius: '15px', boxShadow: '0 10px 30px rgba(0,0,0,0.1)' }}>
          <h4 style={{ color: '#3b82f6', fontSize: '1.4rem', marginBottom: '15px' }}>📞 Contact Information</h4>
          <p><strong>Phone:</strong> +91-9040736524</p>
          <p><strong>Email:</strong> support@tiketjini.com</p>
          <p><strong>Website:</strong> https://tiketjini.com</p>
        </div>
        <div style={{ background: 'white', padding: '30px', borderRadius: '15px', boxShadow: '0 10px 30px rgba(0,0,0,0.1)' }}>
          <h4 style={{ color: '#3b82f6', fontSize: '1.4rem', marginBottom: '15px' }}>🏢 Company Details</h4>
          <p><strong>Bijdutronix Innovations Pvt Ltd</strong></p>
          <p>Technology Solutions Provider</p>
          <p>Specializing in Government Digitization</p>
        </div>
      </div>
      <div style={{ marginTop: '40px' }}>
        <h3 style={{ color: '#3b82f6' }}>Ready for Live Demo</h3>
        <p style={{ fontSize: '1.2rem', color: '#64748b' }}>Schedule a presentation to see ParkJini in action</p>
      </div>
    </div>,

    // Slide 11: Q&A
    <div key={11}>
      <h2 style={{ fontSize: '2.5rem', color: '#3b82f6', marginBottom: '30px' }}>❓ Questions & Answers</h2>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(400px, 1fr))', gap: '30px', margin: '30px 0' }}>
        <div style={{ background: 'white', padding: '30px', borderRadius: '15px', boxShadow: '0 10px 30px rgba(0,0,0,0.1)' }}>
          <h4 style={{ color: '#3b82f6', fontSize: '1.2rem', marginBottom: '10px' }}>Q: What is the implementation timeline?</h4>
          <p style={{ color: '#64748b' }}>A: Same day onboarding as platform is ready, 1 week for full deployment with training and integration.</p>
        </div>
        <div style={{ background: 'white', padding: '30px', borderRadius: '15px', boxShadow: '0 10px 30px rgba(0,0,0,0.1)' }}>
          <h4 style={{ color: '#3b82f6', fontSize: '1.2rem', marginBottom: '10px' }}>Q: What are the upfront costs?</h4>
          <p style={{ color: '#64748b' }}>A: No upfront costs. Revenue sharing model based on transaction volume.</p>
        </div>
        <div style={{ background: 'white', padding: '30px', borderRadius: '15px', boxShadow: '0 10px 30px rgba(0,0,0,0.1)' }}>
          <h4 style={{ color: '#3b82f6', fontSize: '1.2rem', marginBottom: '10px' }}>Q: How secure is the payment system?</h4>
          <p style={{ color: '#64748b' }}>A: PCI DSS compliant with 256-bit SSL encryption and fraud detection.</p>
        </div>
        <div style={{ background: 'white', padding: '30px', borderRadius: '15px', boxShadow: '0 10px 30px rgba(0,0,0,0.1)' }}>
          <h4 style={{ color: '#3b82f6', fontSize: '1.2rem', marginBottom: '10px' }}>Q: Can it handle high traffic?</h4>
          <p style={{ color: '#64748b' }}>A: Yes, cloud-based architecture scales automatically to handle peak loads.</p>
        </div>
        <div style={{ background: 'white', padding: '30px', borderRadius: '15px', boxShadow: '0 10px 30px rgba(0,0,0,0.1)' }}>
          <h4 style={{ color: '#3b82f6', fontSize: '1.2rem', marginBottom: '10px' }}>Q: What support is provided?</h4>
          <p style={{ color: '#64748b' }}>A: 24/7 technical support, training, and dedicated account management.</p>
        </div>
        <div style={{ background: 'white', padding: '30px', borderRadius: '15px', boxShadow: '0 10px 30px rgba(0,0,0,0.1)' }}>
          <h4 style={{ color: '#3b82f6', fontSize: '1.2rem', marginBottom: '10px' }}>Q: Is customization possible?</h4>
          <p style={{ color: '#64748b' }}>A: Yes, full white-label solution with custom branding and features.</p>
        </div>
      </div>
    </div>,

    // Slide 12: Thank You
    <div key={12} style={{ textAlign: 'center', paddingTop: '150px' }}>
      <div style={{ width: '120px', height: '120px', background: '#3b82f6', borderRadius: '20px', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'white', fontSize: '3rem', fontWeight: 'bold', margin: '0 auto 40px' }}>PJ</div>
      <h1 style={{ fontSize: '4rem', color: '#1e293b', marginBottom: '30px' }}>Thank You!</h1>
      <div style={{ background: 'linear-gradient(135deg, #3b82f6, #8b5cf6)', color: 'white', padding: '50px', borderRadius: '25px', margin: '40px auto', maxWidth: '600px' }}>
        <h2 style={{ fontSize: '2rem', marginBottom: '20px' }}>Ready to Transform Ticketing?</h2>
        <p style={{ fontSize: '1.3rem', marginBottom: '30px' }}>Let's discuss how ParkJini can revolutionize your ticketing operations</p>
        <div style={{ fontSize: '1.5rem', fontWeight: 'bold' }}>
          <p>📞 +91-9040736524</p>
          <p>✉️ support@tiketjini.com</p>
        </div>
      </div>
      <p style={{ fontSize: '1.2rem', color: '#64748b', marginTop: '40px' }}>Bijdutronix Innovations Private Limited</p>
    </div>
  ];

  return (
    <div style={{ minHeight: '100vh', background: '#f8fafc', fontFamily: 'Segoe UI, Tahoma, Geneva, Verdana, sans-serif' }}>
      <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '60px 40px' }}>
        {slides[currentSlide]}
      </div>

      <div style={{ position: 'fixed', bottom: '30px', right: '30px', zIndex: 1000 }}>
        <button onClick={prevSlide} style={{ background: '#3b82f6', color: 'white', border: 'none', padding: '15px 25px', margin: '5px', borderRadius: '10px', cursor: 'pointer', fontSize: '16px' }}>
          ← Previous
        </button>
        {currentSlide < totalSlides - 1 && (
          <button onClick={nextSlide} style={{ background: '#3b82f6', color: 'white', border: 'none', padding: '15px 25px', margin: '5px', borderRadius: '10px', cursor: 'pointer', fontSize: '16px' }}>
            Next →
          </button>
        )}
      </div>

      <div style={{ position: 'fixed', bottom: '30px', left: '30px', background: 'rgba(0,0,0,0.7)', color: 'white', padding: '10px 20px', borderRadius: '20px' }}>
        {currentSlide + 1} / {totalSlides}
      </div>
    </div>
  );
};

export default Presentation;